<template>
  <div :class="getClass()" :style="[playerColor]">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPageLoader"
      :color="loaderColor"
    ></loading>
    <div v-if="loading" class="w-full h-full"><loader theme="dark" /></div>
    <div v-else class="flex flex-wrap -mx-3">
      <!-- Play video modal starts -->
      <gd-modal
        ref="playVideoModal"
        name="play-video-modal"
        :title="$t('frontend_groovevideo_library_preview_video')"
        width="60vw"
        class="video-preview-modal"
      >
        <div
          class="flex items-center justify-center w-full"
          v-if="videoPreview"
        >
          <video-player
            id="vid2"
            :options="videoPreview"
            :class="vjsClass"
            data-setup='{ "playbackRates": [0.5, 1, 1.5, 2] }'
          ></video-player>
        </div>
      </gd-modal>
      <!-- Play video modal ends -->
      <div class="w-full space-y-5 mx-2">
        <div class="filters flex justify-between tiles-custom-container pl-3">
          <div class="flex space-x-5">
            <!-- <div>
              <select
                class="text-sm bg-white p-2 border border-grey-300 rounded-lg"
                :placeholder="
                  $t('frontend_groovevideo_videos_index_affiliate_types')
                "
                @change="resetDefautsAndLoad"
                v-model="selectedCategory"
              >
                <option
                  v-for="option in categories"
                  :key="option.id"
                  :value="option.id"
                >
                  {{ option.category }}
                </option>
              </select>
            </div> -->
            <!-- <div>
              <select
                class="text-sm bg-white p-2 border border-grey-300 rounded-lg"
                :placeholder="
                  $t('frontend_groovevideo_videos_index_affiliate_types')
                "
                @change="resetDefautsAndLoad"
                v-model="selectedOrder"
              >
                <option
                  v-for="option in timeOptions"
                  :key="option.id"
                  :value="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
            </div> -->
            <div>
              <treeselect
                v-model="selectedCategory"
                class="h-10 groovevideo-multilevel-select video-category filter-dropdown"
                :multiple="false"
                :options="categories"
                :closeOnSelect="true"
                :clearable="false"
                :clearOnSelect="true"
                :isDefaultExpanded="true"
                :defaultExpandLevel="1"
                :showCount="true"
                :max-height="200"
                :normalizer="normalizer"
                @input="resetDefautsAndLoad"
                :placeholder="
                  $t('frontend_groovevideo_videos_index_affiliate_types')
                "
              />
            </div>
            <div>
              <gd-dropdown
                :options="timeOptions"
                class="text-sm text-grey-700 h-10 video-select"
                v-model="selectedOrder"
                size="full"
                @change="resetDefautsAndLoad"
                :style="{ maxHeight }"
              ></gd-dropdown>
            </div>
          </div>

          <div
            class="
              search-wrapper
              flex
              items-center
              border
              rounded-lg
              border-grey-300
              pl-2
              text-grey-300
            "
          >
            <i class="fa fa-search"></i>
            <text-input
              v-model="searchVideoName"
              class="text-sm border-none"
              :placeholder="$t('frontend_groovevideo_videos_index_search_for')"
              v-debounce:1s="resetDefautsAndLoad"
            />
          </div>
        </div>
        <div class="w-full tiles-custom-container">
          <div
            class="
              grid
              gap-8
              grid-cols-1
              md:grid-cols-2
              lg:grid-cols-3
              xl:grid-cols-4
              2xl:grid-cols-6
              pr-2
            "
          >
            <div
              class="mx-3 video-tile-wrapper"
              v-for="(video, index) in videos"
              :key="index"
            >
              <video-tile
                :video="video"
                :highlight="video.id === selectedVideo.id"
                @playVideo="playVideo"
                @selectVideo="selectVideo(video)"
                @togglePublish="togglePublish($event)"
              ></video-tile>
            </div>
          </div>
        </div>
        <div class="pb-4">
          <infinite-loading
            ref="infiniteLoading"
            @infinite="infiniteHandler"
            spinner="spiral"
            :identifier="infiniteId"
          >
            <div class="text-grey-800" slot="no-more">
              {{ $t('frontend_groovevideo_no_more_videos') }}
            </div>
            <div class="text-grey-800" slot="no-results">
              {{ $t('frontend_groovevideo_no_more_videos') }}
            </div>
          </infinite-loading>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@groovepages/gd-lib/api';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { cloneDeep } from 'lodash';
import Swal from 'sweetalert2';
import InfiniteLoading from 'vue-infinite-loading';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import mixins from '../../mixins';
import Loader from '../Loader';
import parseVideoHelper from './helpers/parseVideo';
import themeConfig from '../../themeConfig.js';
import VideoPlayer from './VideoPlayer';
import VideoTile from './VideoTile';
import './assets/VideoLibrary.scss';

export default {
  name: 'MyVideos',
  mixins: [mixins],
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          videoEmbed: '',
          videoSrc: ''
        };
      }
    },
    primary: Boolean,
    dark: Boolean,
    srcType: {}
  },
  data() {
    return {
      loading: true,
      hasNext: true,
      infiniteId: +new Date(),
      page: 1,
      limit: 12,
      searchVideoName: '',
      selectedCategory: 0,
      selectedOrder: 'id-desc',
      videos: [],
      categories: [],
      videoPreview: null,
      selectedVideo: {},
      vjsClass: 'video-js vjs-big-play-centered',
      maxHeight: { 'max-height': '100px' },
      isLoading: false,
      fullPageLoader: true,
      loaderColor: themeConfig.appPrimaryColor,
    };
  },
  components: {
    Loader,
    VideoTile,
    VideoPlayer,
    InfiniteLoading,
    Treeselect,
    Loading
  },
  computed: {
    playerColor() {
      return {
        '--player-primary-color': 'rgba(253, 100, 129, 0.8)',
        '--player-secondary-color': 'rgba(255,255,255, 1)'
      };
    },
    timeOptions() {
      return [
        {
          value: 'name-asc',
          text: this.$t('frontend_groovevideo_timeoptions_name_asc')
        },
        {
          value: 'name-desc',
          text: this.$t('frontend_groovevideo_timeoptions_name_desc')
        },
        {
          value: 'id-asc',
          text: this.$t('frontend_groovevideo_timeoptions_first_created')
        },
        {
          value: 'id-desc',
          text: this.$t('frontend_groovevideo_timeoptions_last_created')
        },
        {
          value: 'updated_at-asc',
          text: this.$t('frontend_groovevideo_timeoptions_first_updated')
        },
        {
          value: 'updated_at-desc',
          text: this.$t('frontend_groovevideo_timeoptions_last_updated')
        }
      ];
    }
  },
  methods: {
    showLoader() {
      this.loading = true;
    },
    hideLoader() {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    showFullPageLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },
    hideFullPageLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },
    normalizer(node) {
      return {
        id: node.id,
        label: node.category,
        children: node.child && node.child.length ? node.child : undefined,
        user_id: node.user_id
      };
    },
    getClass() {
      let bgClass = 'bg-white';
      let textColor = 'text-pink-dark focus:text-black';
      let borderColor = '';
      let shadowClass = 'hover:shadow-lg focus:shadow-lg';

      if (this.hasState('primary')) {
        bgClass = 'bg-grey-600';
        borderColor = 'border-grey-600';
        shadowClass = '';
        textColor = 'text-white';
      } else if (this.hasState('dark')) {
        bgClass = '';
        borderColor = 'border-grey-700';
        shadowClass = '';
        textColor = 'text-grey-500';
      } else {
        bgClass = '';
        textColor = 'text-black';
        borderColor = 'border-grey-300';
        shadowClass = '';
      }

      return `my-videos video-listing-page px-5 ${bgClass} ${borderColor} ${shadowClass} ${textColor}`;
    },
    async resetDefautsAndLoad() {
      this.page = 1;
      this.videos = [];
      this.infiniteId += 1;
    },
    infiniteHandler($state) {
      this.loadVideos().then(newVideos => {
        if (newVideos.length > 0) {
          this.page += 1;
          this.videos.push(...newVideos);
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    async loadVideos() {
      try {
        const videoData = await api.get(
          `${window.config.apiCoreUrl}/groovevideo/videos?filter[category]=${
            this.selectedCategory
          }&filter[search]=${this.searchVideoName}${
            this.srcType !== undefined ? `&filter[srcType]=${this.srcType}` : ''
          }&sort=${this.selectedOrder}&page=${this.page}&limit=${this.limit}`
        );

        return videoData.data;
      } catch (err) {
        return [];
      }
    },
    async loadCategories() {
      try {
        const categoryData = await api
          .get(`${window.config.apiCoreUrl}/groovevideo/category`)
          .then(d => d.data);

        return [
          { id: 0, category: 'All Categories', user_id: 0 },
          ...categoryData
        ];
      } catch (err) {
        return [{ id: 0, category: 'All Categories', user_id: 0 }];
      }
    },
    selectVideo(video) {
      this.selectedVideo = cloneDeep(video);
      this.emitSelection();
    },
    resetSelectedVideo({ id }) {
      this.selectedVideo = {
        id,
        video_embed: this.value.videoEmbed,
        video_source: this.value.videoSrc
      };
      this.emitSelection();
    },
    emitSelection() {
      this.$emit('selected', this.selectedVideo);
    },
    resetOldVideo(videoId) {
      const video = this.videos.find((v) => v.id === videoId);
      if(video) {
        this.selectVideo(video);
      } else {
        this.resetSelectedVideo({
          id: videoId
        });
      }
    },
    getVideo(video) {},
    viewVideo(videoId) {},
    cloneVideo(videoId) {},
    deleteVideo(videoId) {},
    playVideo(video) {},
    getVideoEmbed(video) {
      if (
        (video.video_source && video.video_source !== '') ||
        (video.is_local == 1 && video.video_stream_source !== null && video.video_stream_source != '')
      ) {
        /** until when we get it done through groovevideo */
        const { id, type } = parseVideoHelper(video.video_source);
        if (type === 'vimeo') {
          return `<iframe class="custom-embed-iframe" src='https://player.vimeo.com/video/${id}' frameborder='0'  allowfullscreen width='100%' height='400'></iframe>`;
        }

        return `<groovevideo-widget id="${video.id}" permalink="${video.permalinks}"></groovevideo-widget>`;
      }
      return '';
    },
    setVideoEmbed(videoEmbed) {
      this.selectedVideo.video_embed = videoEmbed;
    },
    async togglePublish(videoId) {
      const index = this.videos.findIndex((v) => v.id === videoId);
      if(index < 0) return;

      this.showFullPageLoader();
      const isPublish = !this.videos[index].is_published ? 1 : 0;

      const response = await api.post(
        `${window.config.apiCoreUrl}/groovevideo/videos/${videoId}/publish`,
        { is_published:  isPublish },
        true
      );
      this.hideFullPageLoader();

      if (response.status && response.message === 'published_successfully') {
        this.videos[index].is_published = isPublish;
        if(!isPublish && this.selectedVideo.id === this.videos[index].id) {
          this.resetSelectedVideo({ id: 0 });
        }
        return;
      }
      this.showAlertBox(this.$t('frontend_groovevideo_links_publish_fail'));
    },
    showAlertBox(text) {
      Swal.fire({
        title: 'Error',
        text,
        reverseButtons: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel'
      });
    }
  },
  async mounted() {
    this.showLoader();
    try {
      this.categories = await this.loadCategories();
      this.resetSelectedVideo({ id: 0 });
    } catch (err) {
      /** */
    }
    this.hideLoader();
    return false;
  },
  watch: {
    'selectedVideo.id': {
      deep: false,
      handler(newVideoId, oldVideoId) {
        if (!newVideoId) return;

        if (this.selectedVideo.is_published !== undefined && !this.selectedVideo.is_published) {
          this.showAlertBox(this.$t('frontend_groovevideo_publish_video_info'));
          this.resetOldVideo(oldVideoId);
          return;
        }
        // if (
        //   [1].includes(this.selectedVideo.video_source_type) &&
        //   (!this.selectedVideo.video_encoding ||
        //     !this.selectedVideo.video_encoding.is_complete)
        //   /** uploaded videos */
        // ) {
        //   this.showAlertBox('Encoding is in process. Please choose another video');
        //   this.resetSelectedVideo({
        //     id: oldVideoId
        //   });
        //   return;
        // }

        this.setVideoEmbed(this.getVideoEmbed(this.selectedVideo));
      }
    }
  }
};
</script>
<style lang="scss">
.my-videos {
  .vjs-control-bar,
  .cta-optin-form-submit-button.videoBtn,
  .cta-optin-form-submit-button.videoBtn:hover,
  .cta-optin-form-submit-button.videoBtn:active,
  .cta-optin-form-submit-button.videoBtn:focus,
  .caption-cta-button-container.cta-overlay .caption-cta-caption-button,
  .caption-cta-button-container.cta-overlay .caption-cta-caption-button:hover,
  .caption-cta-button-container.cta-overlay .caption-cta-caption-button:active {
    background-color: var(--player-primary-color) !important;
  }
  .optin-skip.cta-skip-button:hover,
  .cta-skip-banner-button.banner-skip:hover {
    color: var(--player-primary-color) !important;
  }
  .video-js {
    color: var(--player-secondary-color) !important;
  }
}

.video-listing-page {
  .video-tile-wrapper {
    width: 100%;
    .video-tile {
      .text-sm {
        font-size: 14px;
      }
    }
  }
}

.video-category {
  width: 300px !important;
  &.vue-treeselect {
    font-family: 'Nunito Sans', sans-serif;
    font-size: 14px;
  }
  .vue-treeselect__control {
    border-color: #cccedc !important;
    border-radius: 6px;
    height: 40px;
    padding: 0 16px;
  }
  .vue-treeselect__control-arrow-container {
    position: relative;
    svg {
      display: none;
    }
    &::after {
      content: '';
      display: inline-block;
      border: solid #dcdcea;
      border-width: 0 2px 2px 0;
      display: inline-block;
      margin-top: -5px;
      padding: 3px;
      transform: rotate(45deg);
    }
  }
  .vue-treeselect__single-value {
    color: #191d3a;
  }
  .vue-treeselect__single-value,
  .vue-treeselect__placeholder {
    padding-left: 8px;
    line-height: 38px;
  }
  .vue-treeselect__menu-container {
    z-index: 9 !important;
    .vue-treeselect__menu {
      width: 100%;
      padding: 0 0;
      border: none;
      border-radius: 6px;
      box-shadow: 20px 20px 40px 0 rgba(22, 29, 37, 0.05);
    }
    .vue-treeselect__list {
      overflow: auto;
      .vue-treeselect__option {
        padding: 8px 12px;
        color: #545671;
        &:hover {
          background-color: #191c3c;
          color: #fff;
        }
      }
      .vue-treeselect__label {
        font-size: 14px;
        font-weight: 600;
      }
    }
  }

  .active .fa-chevron-right {
    transform: rotate(90deg);
  }
}

.groovevideo-multilevel-select {
  .vue-treeselect__control {
    .vue-treeselect__input-container,
    .vue-treeselect__single-value {
      padding: 0;
    }
  }
  .vue-treeselect__menu > .vue-treeselect__list {
    .vue-treeselect__list {
      overflow: visible;
      padding: 0;
      .vue-treeselect__option {
        padding: 4px 32px;
      }
    }
    .vue-treeselect__indent-level-1 {
      .vue-treeselect__label::before {
        width: 8px;
        height: 1px;
        background: #545671;
        content: '';
        margin: 0 6px 0 0;
      }
    }
  }
  .vue-treeselect__option--disabled
    .vue-treeselect__label-container
    .vue-treeselect__label {
    color: rgba(0, 0, 0, 0.25);
  }
}

.search-wrapper div {
  border-radius: 6px !important;
}
</style>
